export default {
  app_title: process.env.VUE_APP_TITLE,
  app_env: process.env.VUE_APP_ENV,
  app_default_locale: 'en',
  api_url: process.env.VUE_APP_API_URL,
  google_map_search_url: 'https://maps.google.com/?q='
}
